import Rest from '@/services/Rest';

/**
 * @typedef {CheckoutService}
 */
export default class CheckoutService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/checkout'
}
